<template>
  <div class="modal fade" id="harvest-create-package" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div :class="`block-header bg-${color}`">
            <h3 class="block-title"><i class="fa fa-box-open"></i> Create Package</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="row">
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 required">
                <label class="control-label">Tag</label>
                <input v-model="pack.tag" name="tag" v-validate="'required'" data-vv-as="Tag" type="text" class="form-control form-control-alt" placeholder="Tag">
                <p v-if="errors.has('tag')" class="errorMsg">{{ errors.first('tag') }}</p>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 required">
                <label class="control-label">Select item</label>
                <select id="package-item" placeholder="Select Item.." class="form-control package-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(item, index) in library.items" :key="index" :bind:value="item.Name">{{ item.Name }}</option>
                </select>
                <p v-if="itemError" class="errorMsg">The Item field is required.</p>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 required">
                <label class="control-label">Room</label>
                <select id="package-room" placeholder="Select Room.." class="form-control package-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(room, index) in library.rooms" :key="index" :bind:value="room.Name">{{ room.Name }}</option>
                </select>
                <p v-if="roomError" class="errorMsg">The Room field is required.</p>
              </div>
              <div v-show="harvestId" class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 required">
                <label class="control-label">Weight</label>
                <input v-model="pack.weight" name="weight" @keyup="weightError = false" type="number" onkeypress="return event.charCode >= 48" min="1" class="form-control form-control-alt" placeholder="Weight">
                <p v-if="weightError" class="errorMsg">The Wight field is required.</p>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 required">
                <label class="control-label">Unit Of Weight</label>
                <select id="package-measurement" placeholder="Select Unit Of Weight.." class="form-control package-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(unit, index) in library.unitOfMeasurement" :key="index" :bind:value="unit.Name">{{ unit.Name }}</option>
                </select>
                <p v-if="measurementError" class="errorMsg">The Unit Of Weight field is required.</p>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <label>Creation Date</label>
                <input type="text" name="date" id="creation-date" v-model="pack.date" placeholder="Creation Date" class="form-control form-control-alt datepicker">
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 toggle-button">
                <label>Product Requires Remediation?</label>
                <div class="custom-control custom-switch custom-control-inline">
                  <input type="checkbox" v-model="pack.productRequiresRemediation" @change="pack.remediateProduct = false" id="remediation-status" class="custom-control-input">
                  <label class="custom-control-label" for="remediation-status"></label>
                </div>
              </div>
              <transition name="slide-fade">
                <div v-show="pack.productRequiresRemediation" class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                  <label>Remediation Method Id</label>
                  <input type="text" v-model="pack.remediationMethodId" class="form-control form-control-alt" placeholder="Remediation Method Id">
                </div>
              </transition>
              <transition name="slide-fade">
                <div v-show="pack.productRequiresRemediation" class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                  <label>Remediation Steps</label>
                  <input type="text" name="remediationSteps" v-model="pack.remediationSteps" placeholder="Remediation Steps" class="form-control form-control-alt">
                </div>
              </transition>
              <transition name="slide-fade">
                <div v-show="pack.productRequiresRemediation" class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                  <label>Remediation Date</label>
                  <input type="text" name="remediationDate" id="remidiation-date" v-model="pack.remediationDate" placeholder="Remediation Date" class="form-control form-control-alt datepicker">
                </div>
              </transition>
              <transition name="slide-fade">
                <div v-show="pack.productRequiresRemediation" class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 toggle-button">
                  <label>Remediate Product?</label>
                  <div class="custom-control custom-switch custom-control-inline">
                    <input type="checkbox" v-model="pack.remediateProduct" id="product-remediation-status" class="custom-control-input">
                    <label class="custom-control-label" for="product-remediation-status"></label>
                  </div>
                </div>
              </transition>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 toggle-button">
                <label>Production Has Batch?</label>
                <div class="custom-control custom-switch custom-control-inline">
                  <input type="checkbox" v-model="pack.isProductionBatch" id="production-batch" class="custom-control-input">
                  <label class="custom-control-label" for="production-batch"></label>
                </div>
              </div>
              <transition name="slide-fade">
                <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" v-if="pack.isProductionBatch">
                  <label>Production Batch Number</label>
                  <input type="text" v-model="pack.productionBatchNumber" placeholder="Production Batch Number" class="form-control form-control-alt">
                </div>
              </transition>
              <div v-show="!harvestId" class="form-group col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 clone-content">
                <div class="form-group clone-buttons">
                  <h4 class="clone-title">Ingredients</h4>
                  <button href="#" title="Click to add" id='facilityIcon' @click="addIngredients()" :class="`clone btn text-${color}`" v-scroll-to="{ element:'#pageControll', duration: 3000 }"><i class="fa fa-fw fa-plus-square mr-1"></i>Add</button>
                </div>
                <div v-for="(ingredient, index) in ingredients" :key="index" v-bind:class="[ index == 0  ? 'border-facility block-content cloning-content'  : 'remove-facility border-facility block-content' ]">
                  <div class="row" :key="index">
                    <div v-if="index > 0" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-end">
                      <button href="#" title="Click to delete" @click="removeIngredient(index)" class="clone btn delete-icon text-danger"><i class="fa fa-trash-alt"></i></button>
                    </div>
                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      <label>Harvest Name</label>
                      <select :id="`harvest-${index}`" :data-packId="index" placeholder="Select Harvest Name.." class="form-control package-label package-select2-dropdown" style="width: 100%;">
                        <option></option>
                        <option v-for="(harvest, index) in library.harvests" :key="index" :bind:value="harvest.Name">{{ harvest.Name }}</option>
                      </select>
                    </div>
                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      <label>Weight</label>
                      <input v-model="ingredient.Weight" type="number" onkeypress="return event.charCode >= 48" min="1" class="form-control form-control-alt" placeholder="Weight">
                    </div>
                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      <label>Unit Of Weight</label>
                      <select :id="`measure-unit-${index}`" :data-unitId="index" placeholder="Select Unit Of Weight.." class="form-control package-select-box package-select2-dropdown" style="width: 100%;">
                        <option></option>
                        <option v-for="(unit, index) in library.unitOfMeasurement" :key="index" :bind:value="unit.Name">{{ unit.Name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="pageControll" class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" :class="`btn btn-sm btn-${color}`" @click="createPackage" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapActions, mapState } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'CreatePackage',
  data() {
    return {
      pack: {
        harvestId: 0,
        tag: '',
        room: null,
        item: null,
        weight: 1,
        unitOfWeight: null,
        isProductionBatch: false,
        productionBatchNumber: '',
        productRequiresRemediation: false,
        remediateProduct: false,
        remediationMethodId: '',
        patientLicenseNumber: '',
        remediationSteps: '',
        date: new Date().toJSON().slice(0,10),
        remediationDate: new Date().toJSON().slice(0,10)
      },
      ingredients: [{HarvestName: '', Weight: 1, UnitOfWeight: ''}],
      errorMsg: '',
      itemError: false,
      roomError: false,
      measurementError: false,
      weightError: false,
      i: 0,
      showModalLoader: false,
      color: 'primary'
    };
  },
  computed: {
    ...mapState({
      library: state => state.library
    }),
    harvestId() {
      return this.pack.harvestId; 
    }
  },
  mounted() {
    let vm = this;
    $('.datepicker').datepicker({ format: 'yyyy-mm-dd', autoclose:true });
    $('#package-room').on('change', function () { vm.pack.room = $(this).val(); vm.roomError = false; } );
    $('#package-item').on('change', function () { vm.pack.item = $(this).val(); vm.itemError = false; } );
    $('#package-measurement').on('change', function () { vm.pack.unitOfWeight = $(this).val(); vm.measurementError = false; } );
    $('.package-select-box').on('change', function(){
      let index = $(this).attr('data-unitId');
      vm.ingredients[index].UnitOfWeight = $(this).val();
    });
    $('.package-label').on('change', function(){
      let index = $(this).attr('data-packId');
      vm.ingredients[index].HarvestName = $(this).val();
    });
    $('#creation-date').change(function() { vm.pack.date = $(this).val(); });
    $('#remidiation-date').change(function() { vm.pack.remediationDate = $(this).val(); });
  },
  components: {
    HashLoader
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllPackages']),
    createPackage() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validate() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          let url = vm.pack.harvestId ? '/harvests/createpackages' : '/harvests/create_packages';
          helper.sendPostRequest(url, {
            'Harvest': vm.pack.harvestId,
            'Tag': vm.pack.tag,
            'Room': vm.pack.room,
            'Item': vm.pack.item,
            'UnitOfWeight': vm.pack.unitOfWeight,
            'Weight': vm.pack.weight,
            'IsProductionBatch': vm.pack.isProductionBatch,
            'ProductionBatchNumber': vm.pack.productionBatchNumber,
            'ProductRequiresRemediation': vm.pack.productRequiresRemediation,
            'PatientLicenseNumber': vm.pack.patientLicenseNumber,
            'RemediateProduct': vm.pack.remediateProduct,
            'RemediationMethodId': vm.pack.remediationMethodId,
            'RemediationDate': vm.pack.remediationDate,
            'RemediationSteps': vm.pack.remediationSteps,
            'ActualDate': vm.pack.date,
            'Ingredients': Object.keys(vm.ingredients).length > 1 || vm.ingredients[0].HarvestName !== '' ? vm.ingredients : [],
          }).then((data) => {
            if (data.status === 'success') {
              jQuery('#harvest-create-package').modal('hide');
              vm.triggerMessageModal('#alert_modal');
              vm.showModalLoader = false;
              vm.clearData();
              helper.getPackages();
              vm.getAllPackages();
              helper.showSuccessModal(data.message);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    addIngredients() {
      this.ingredients.push({ HarvestName: '', Weight: 1, UnitOfWeight: ''});
      this.i++;
      let vm = this;
      setTimeout(() => {
        $('#harvest-' + vm.i).select2({
          dropdownParent: $('#harvest-' + vm.i).parent(),
          placeholder: 'Select Harvest Name..'
        });
        $('#harvest-' + vm.i).on('change', function(){
          vm.ingredients[vm.i].HarvestName = $(this).val();
        });
        $('#measure-unit-' + vm.i).select2({
          dropdownParent: $('#measure-unit-' + vm.i).parent(),
          placeholder: 'Select Unit Of Weight..'
        });
        $('#measure-unit-' + vm.i).on('change', function(){
          vm.ingredients[vm.i].UnitOfWeight = $(this).val();
        });
      }, 500);
    },
    removeIngredient(index) {
      this.ingredients.splice(index, 1);
      this.i--;
    },
    setData(id, color) {
      this.pack.harvestId = id;
      this.color = color;
    },
    clearData() {
      let vm = this;
      Object.keys(vm.pack).map(function(key){ return vm.pack[key] = ''; });
      this.errorMsg = '';
      this.pack.date = new Date().toJSON().slice(0,10);
      this.pack.harvestId = 0;
      this.pack.weight = 1;
      this.pack.remediationDate = new Date().toJSON().slice(0,10);
      $('.package-select2-dropdown').val(null).trigger('change');
      if (vm.ingredients) {
        vm.ingredients.forEach((v, i) => {
          vm.removeIngredient(i);
        });
      }
      $('.datepicker').datepicker('update', vm.pack.date);
      vm.ingredients = [{ HarvestName: '', Weight: 1, UnitOfWeight: ''}];
      this.$validator.reset();
    },
    validate() {
      if (!this.pack.item) {
        this.itemError = true;
      }
      if (!this.pack.room) {
        this.roomError = true;
      }
      if (!this.pack.unitOfWeight) {
        this.measurementError = true;
      }
      if (this.pack.harvestId && !this.pack.weight) {
        this.weightError = true;
      }
      if (this.itemError || this.roomError || this.measurementError || this.weightError) {
        return false;
      }
      return true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// source/components/modals/CreatePackage.vue